var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliedCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 98,
    viewBox: "0 0 81 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-be74e05a": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39999 97.1H12.1C12.1 92.7 17.3 89 23.5 89C29.7 89 35 92.6 35 97H46.5C46.5 92.6 51.6 88.9 57.9 88.9C64.1 88.9 69.4 92.5 69.4 96.9H75.1C78.3 96.9 80.8 94.3 80.8 92.8C80.8 91.3 80.1 4.09998 80.1 4.09998C80.1 1.89998 77.5 0.0999756 74.4 0.0999756H68.7C68.7 4.49998 63.5 8.39996 57.3 8.39996C51.1 8.39996 45.8 4.59998 45.8 0.199978H34.5C34.5 4.59998 29.3 8.29996 23.1 8.29996C16.9 8.29996 11.6 4.49998 11.6 0.0999756H6.29999C3.09999 0.0999756 0.599993 2.69998 0.599993 5.09998L0.599998 92.8C0.599999 95.2 3.09999 97.1 6.39999 97.1Z",
    fill: "#01C267",
    "data-v-be74e05a": ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39999 97.1C3.19999 97.1 0.699997 95.3 0.699997 93.1L0.5 70.5L80.6 70.2L80.8 92.8C80.8 95 78.3 96.9 75.1 96.9H69.4C69.4 92.5 64.1 89 57.9 89C51.7 89 46.5 92.6 46.5 97H35C35 92.6 29.8 88.9 23.5 89C17.3 89 12 92.7 12.1 97.1H6.39999Z",
    fill: "#0F804A",
    "data-v-be74e05a": ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 26.5C24.3 24 30.2 23.1 34.8 26.3C39.4 29.5 38.2 33.7 34.7 36.2C31.2 38.7 25.3 39.6 20.7 36.4C18.6 34.9 17.5 33.1 17.7 31.1C17.9 29.4 19 27.8 20.8 26.5ZM30.6 33.4C30.9 33.2 33.5 31.2 30.7 29.2C27.9 27.2 25.1 29.1 24.8 29.3C24 29.9 23.5 30.6 23.4 31.3C23.3 32.1 23.8 32.8 24.7 33.4C",
    fill: "#F5F5F5",
    "data-v-be74e05a": ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44.7C49.5 42.2 55.4 41.3 60 44.5C64.6 47.7 63.4 51.9 59.9 54.4C56.4 56.9 50.5 57.8 45.9 54.6C41.4 51.4 42.5 47.2 46 44.7ZM55.9 51.6C56.2 51.4 58.8 49.4 56 47.4C53.2 45.4 50.4 47.3 50.1 47.5C49.8 47.7 47.2 49.7 50 51.7C52.8 53.7 55.5 51.8 55.9 51.6Z",
    fill: "#F5F5F5",
    "data-v-be74e05a": ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 15.6H13.5V66H71.9V15.6Z",
    fill: "#01C267",
    "data-v-be74e05a": ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30.5C22 28 22.7 26.1 24.1 24.7C25.6 23.3 27.4 22.6 29.7 22.6C32 22.6 33.8 23.3 35.2 24.7C36.7 26.1 37.4 28 37.4 30.5C37.4 33 36.7 34.9 35.2 36.3C33.8 37.7 31.9 38.4 29.7 38.4C27.4 38.4 25.6 37.7 24.1 36.3C22.8 35 22 33 22 30.5ZM53.2 23.3L34.1 57.2H27.5L46.5 23.3H53.2ZM29.7 26.7C27.9 26",
    fill: "white",
    "data-v-be74e05a": ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8 91.3H74.4V96.7H80.8V91.3Z",
    fill: "#0F804A",
    "data-v-be74e05a": ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1 0.0999756H73.7V5.5H80.1V0.0999756Z",
    fill: "#01C267",
    "data-v-be74e05a": ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedCoupon);
export default __webpack_public_path__ + "static/media/applied-coupon.e6796842df53f0ee7e4b628ae306129e.svg";
export { ForwardRef as ReactComponent };